'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var renderMark = function renderMark(mark) {
    return MARKS[mark.type];
  };

  return {
    onClickMark: onClickMark,
    renderMark: renderMark
  };
};

var MARKS = {
  bold: {
    fontWeight: 'bold'
  },
  code: {
    fontFamily: 'monospace',
    backgroundColor: '#eee',
    padding: '3px',
    borderRadius: '4px'
  },
  italic: {
    fontStyle: 'italic'
  },
  underlined: {
    textDecoration: 'underline'
  }
};

var hasMark = exports.hasMark = function hasMark(type, state) {
  return state.marks.some(function (mark) {
    return mark.type === type;
  });
};

var onClickMark = exports.onClickMark = function onClickMark(type, state) {
  return state.transform().toggleMark(type).apply();
};


//////////////////
// WEBPACK FOOTER
// ./~/slate-plugins-rich-text/lib/index.js
// module id = 694
// module chunks = 0